import React, { useState, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import NavBar from '../components/NavBar.jsx';
import { IMAGE_CREDITS } from '../creditsData.js';

// Page « Crédits images ».
// Toutes les images du jeu viennent de Wikimedia Commons (PD / CC0 / CC-BY / CC-BY-SA).
// Pour les licences à attribution (CC-BY / CC-BY-SA), le crédit doit être accessible :
// cette page liste chaque image avec un lien vers sa page Commons (auteur + licence exacte).
export default function Credits() {
  const navigate = useNavigate();
  const [q, setQ] = useState('');

  const list = useMemo(() => {
    const needle = q.trim().toLowerCase();
    if (!needle) return IMAGE_CREDITS;
    return IMAGE_CREDITS.filter(c => c.label.toLowerCase().includes(needle));
  }, [q]);

  return (
    <motion.div className="profile-page" initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}>
      <NavBar />
      <div className="profile-content">
        <h2>🖼️ Crédits images</h2>

        <div className="profile-section">
          <p style={{ margin: 0, lineHeight: 1.5, fontSize: 14, opacity: 0.9 }}>
            Toutes les images du jeu proviennent de <strong>Wikimedia Commons</strong> et sont
            libres d'utilisation (domaine public, CC0, CC-BY ou CC-BY-SA). L'auteur et la licence
            exacte de chaque image figurent sur sa page Commons — cliquez sur une image pour l'ouvrir.
          </p>
        </div>

        <div className="profile-section">
          <input
            type="text"
            value={q}
            onChange={e => setQ(e.target.value)}
            placeholder="🔍 Rechercher une image…"
            style={{ width: '100%', padding: '10px 12px', borderRadius: 10, border: '1px solid rgba(255,255,255,0.2)', background: 'rgba(255,255,255,0.06)', color: 'inherit', fontSize: 15 }}
          />
          <div style={{ fontSize: 12, opacity: 0.6, marginTop: 8 }}>
            {list.length} image{list.length > 1 ? 's' : ''}
          </div>
        </div>

        <div className="profile-section" style={{ maxHeight: '55vh', overflowY: 'auto' }}>
          {list.map((c, i) => (
            <a
              key={c.file + i}
              href={c.url}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                display: 'block',
                padding: '8px 4px',
                borderBottom: '1px solid rgba(255,255,255,0.08)',
                color: 'inherit',
                textDecoration: 'none',
                fontSize: 13,
              }}
            >
              {c.label} ↗
            </a>
          ))}
        </div>

        <div className="profile-section">
          <button className="profile-btn secondary" onClick={() => navigate('/profile')}>
            ← Retour
          </button>
        </div>
      </div>
    </motion.div>
  );
}
